// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dWSL","footer":"styles_footer__36PXb"};